module.exports = __webpack_public_path__ + "img/svg/explain-1.1ca3779bfef7988e5860901f800a4470.svg";